import store from '../store/index';
import { TABLE_NUM_ITEMS } from '../constants';

const usersGuard = (to, from, next) => {
  store.dispatch('users/LoadUsers', { offset: 0, limit: TABLE_NUM_ITEMS}).then(() => next());
}

export default usersGuard;
